import { lazy } from "react";
import Loadable from "../../components/Loadable";
import { CHAT } from "../../utils/constant";

const ModernChatMain = Loadable(lazy(() => import("./ModernChatMain")));

const chatRoute = [
  {
    path: "/chat",
    element: <ModernChatMain />,
    permission: CHAT,
  },
];

export default chatRoute;


